/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hplc_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter both column geometries and the original method.`)
};

const es_hplc_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduce ambas geometrías de columna y el método original.`)
};

const de_hplc_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie beide Säulengeometrien und die ursprüngliche Methode ein.`)
};

const nl_hplc_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voer beide kolomgeometrieën en de oorspronkelijke methode in.`)
};

const fr_hplc_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrez les deux géométries de colonne et la méthode d'origine.`)
};

const it_hplc_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci entrambe le geometrie di colonna e il metodo originale.`)
};

const pt_br2_hplc_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informe as duas geometrias de coluna e o método original.`)
};

const pt_hplc_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduza ambas as geometrias de coluna e o método original.`)
};

const ja_hplc_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`両方のカラム形状と元のメソッドを入力してください。`)
};

const zh_hplc_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入两种色谱柱的几何参数及原方法。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hplc_hint = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hplc_hint(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hplc_hint", locale)
	if (locale === "en") return en_hplc_hint(inputs)
	if (locale === "es") return es_hplc_hint(inputs)
	if (locale === "de") return de_hplc_hint(inputs)
	if (locale === "nl") return nl_hplc_hint(inputs)
	if (locale === "fr") return fr_hplc_hint(inputs)
	if (locale === "it") return it_hplc_hint(inputs)
	if (locale === "pt-BR") return pt_br2_hplc_hint(inputs)
	if (locale === "pt") return pt_hplc_hint(inputs)
	if (locale === "ja") return ja_hplc_hint(inputs)
	return zh_hplc_hint(inputs)
};